import React from 'react';
import { motion } from 'framer-motion';
import { getStaticAsset, STATIC_ASSETS, preloadImage } from '../../utils/staticAssets';


const VisionPage = () => {
  return (
    <div className="page-container relative">
      {/* Background */}
      <div className="bg-image-container">
        <img
          src={STATIC_ASSETS.bg02}
          alt="Background"
          className="w-full h-full object-cover"
        />
        </div>

      {/* Content */}
      <div className="content-container relative z-10 flex flex-col justify-center h-full text-center">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="max-w-6xl mx-auto "
        >
      <motion.div
  className="w-full mx-auto flex justify-center overflow-hidden"
  initial={{ scaleX: 0 }}
  animate={{ scaleX: 1 }}
  transition={{ duration: 1, delay: 0.4 }}
>
  <img
    src={STATIC_ASSETS.Our_Vision}
    alt="Decorative line"
    className="w-full max-w-[1176px] object-contain"
  />
</motion.div>
        
       
          {/* Decorative Line */}
          <motion.div
            className="w-full  mx-auto mb-8"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 1, delay: 0.4 }}
          >
          <div
                style={{
                  backgroundImage: `url(${STATIC_ASSETS.Vector})`,
                  backgroundSize: '100% 100%',
                }}
                className="w-full md:w-[1176px] h-auto md:h-[204px] flex justify-center items-center"
              >
                <motion.p
                  className="text-2xl md:text-5xl gradient-text font-normal w-4/5"
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.6 }}
                >
                  Gmatrixs aims to become the Steam of the GameFi era.
                </motion.p>
              </div>

          </motion.div>

          {/* Bottom Line */}
          <motion.div
            className="absolute mt-[9rem] left-1/2 transform -translate-x-1/2 w-full max-w-6xl"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 1 }}
          >
            <img
              src={STATIC_ASSETS.Line_x}
              alt="Bottom line"
              className="w-full h-auto"
            />
          </motion.div>
           <motion.p
            className="absolute  bottom-10 text-xl text-gray-300 max-w-5xl mx-auto leading-relaxed"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
          >
            We believe games should be more than entertainment — they should be open, shared, and co-created worlds where
            players and developers together define value.
          </motion.p>

        </motion.div>
      </div>

      {/* Floating Elements */}
      <motion.div
        className="absolute top-20 right-20 w-20 h-20 opacity-30"
        animate={{ 
          rotate: 360,
          scale: [1, 1.2, 1]
        }}
        transition={{ 
          rotate: { duration: 20, repeat: Infinity, ease: "linear" },
          scale: { duration: 4, repeat: Infinity }
        }}
      >
        <div className="w-full h-full rounded-full bg-gradient-to-r from-blue-500 to-purple-600 blur-sm" />
      </motion.div>

      <motion.div
        className="absolute bottom-32 left-20 w-16 h-16 opacity-20"
        animate={{ 
          y: [0, -20, 0],
          rotate: [0, 180, 360]
        }}
        transition={{ 
          duration: 6, 
          repeat: Infinity,
          ease: "easeInOut"
        }}
      >
        <div className="w-full h-full rounded-full bg-gradient-to-r from-purple-600 to-blue-500 blur-sm" />
      </motion.div>
    </div>
  );
};

export default VisionPage;